import { SkinRole } from '../../lib/skin/getColorSkin/generated/types';

import { AlertLineColor } from './types';

export const skinMap: Record<AlertLineColor['color'], SkinRole> = {
    info: 'info',
    success: 'success',
    warning: 'warning',
    error: 'error',
    message: 'message-lc',
};
